import { Input } from 'antd';
import { normalize } from './normalize';
import type { StringField } from './types';

/**
 * Email address. Lowercased on blur so `Kulkarni@X.com` and `kulkarni@x.com`
 * match the same guardian on lookup. Widget does not regex-validate — that
 * lives in Zod at the API boundary; the widget's job is UX.
 */
export function EmailField({ value, onChange, onBlur, ...rest }: StringField) {
  return (
    <Input
      type="email"
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={() => {
        if (typeof value === 'string') {
          const cleaned = normalize(value, ['trim', 'lower']);
          if (cleaned !== value) onChange?.(cleaned);
        }
        onBlur?.();
      }}
      placeholder={rest.placeholder ?? 'name@example.com'}
      inputMode="email"
      autoComplete="email"
      {...rest}
    />
  );
}
